import { ConversationSyncInfo } from "./chatTypes";

/**
 * localStorage 키 생성
 */
const getSyncStorageKey = (productId: number, roomName: string): string => {
  return `chat_sync_${productId}_${roomName}`;
};

/**
 * 동기화 정보 로드
 * @returns 대화방별 lastReadIndex 정보 배열
 */
export const loadSyncInfo = (
  productId: number,
  roomName: string
): ConversationSyncInfo[] => {
  try {
    const key = getSyncStorageKey(productId, roomName);
    const stored = localStorage.getItem(key);
    if (!stored) return [];

    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Failed to load sync info:", error);
    return [];
  }
};

/**
 * 동기화 정보 저장
 */
export const saveSyncInfo = (
  productId: number,
  roomName: string,
  syncInfo: ConversationSyncInfo[]
): void => {
  try {
    const key = getSyncStorageKey(productId, roomName);
    localStorage.setItem(key, JSON.stringify(syncInfo));
  } catch (error) {
    console.error("Failed to save sync info:", error);
  }
};

/**
 * 특정 대화방의 lastReadIndex 업데이트
 */
export const updateLastReadIndex = (
  productId: number,
  roomName: string,
  conversationKey: string,
  index: number
): void => {
  const syncInfo = loadSyncInfo(productId, roomName);
  const existing = syncInfo.find((s) => s.conversationKey === conversationKey);

  if (existing) {
    // 기존 인덱스보다 큰 경우에만 업데이트
    if (index > existing.lastReadIndex) {
      existing.lastReadIndex = index;
    }
  } else {
    // 새 대화방 추가
    syncInfo.push({ conversationKey, lastReadIndex: index });
  }

  saveSyncInfo(productId, roomName, syncInfo);
};

/**
 * 특정 대화방의 lastReadIndex 조회
 * @returns lastReadIndex (없으면 0)
 */
export const getLastReadIndex = (
  productId: number,
  roomName: string,
  conversationKey: string
): number => {
  const syncInfo = loadSyncInfo(productId, roomName);
  const found = syncInfo.find((s) => s.conversationKey === conversationKey);
  return found ? found.lastReadIndex : 0;
};

/**
 * 동기화 정보 삭제 (방 퇴장 시)
 */
export const clearSyncInfo = (productId: number, roomName: string): void => {
  try {
    const key = getSyncStorageKey(productId, roomName);
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Failed to clear sync info:", error);
  }
};
